import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'sh-platform-checkbox',
  templateUrl: './platform-checkbox.component.html',
  styleUrl: './platform-checkbox.component.scss',
  standalone: false
})
export class PlatformCheckboxComponent implements OnInit {
  form = new FormGroup({
    checkbox: new FormControl(true),
    checkboxDisabled: new FormControl(false)
  });

  usage = `
        <ui-platform-checkbox
          formControlName="checkbox"
          [label]="'Checkbox enabled'"
        >
        </ui-platform-checkbox>
    `;

  import = `
    import {UiPlatformCheckbox} from 'ui-platform';
  `;

  visible = true;
  inProgress = false;

  constructor() {}

  ngOnInit(): void {}

  makeVisible(): void {
    this.visible = true;
  }

  closeDrawer(): void {
    this.visible = false;
  }

  toggleInProgress(): void {
    this.inProgress = !this.inProgress;
  }
}
